import moment from "moment";

export const timer = (beforeFunction, afterFunction, timer) => {
  beforeFunction();
  const interval = setInterval(() => {
    afterFunction();
  }, timer);
  return () => clearInterval(interval);
};

export const validateEmail = (email) => {
  const validEmailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,6}$/;
  if (email.match(validEmailRegex)) {
    return true;
  } else {
    return false;
  }
};

export const validatePassword = (password) => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+={}\[\]|\\:;"'<>,.?/~`-]{8,}$/;
  if (passwordRegex.test(password)) {
    return true;
  } else {
    return false;
  }
};

export const dataURLToBlob = (dataurl) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

export const generateRegistrationUUID = (program, signature) => {
  const programCode = program && program.split(" ")[0];
  // get the first ten letters of signature of random 100 chars
  const signatureLastTen = signature
    .substring(signature.length - 100)
    .replace(/(?!\w|\s)./g, "")
    .replace(/\s+/g, "")
    .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, "$2")
    .substring(0, 10)
    .toUpperCase();
  const uuid = `INTERLINK-REG/${programCode}/${signatureLastTen}`;
  return uuid;
};

export const generateAssessmentUUID = (program, signature) => {
  const programCode = program && program.split(" ")[0];
  // get the first ten letters of signature of random 100 chars
  const signatureLastTen = signature
    .substring(signature.length - 100)
    .replace(/(?!\w|\s)./g, "")
    .replace(/\s+/g, "")
    .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, "$2")
    .substring(0, 10)
    .toUpperCase();
  const uuid = `INTERLINK-SAG/WEB/${programCode}/${signatureLastTen}`;
  return uuid;
};

export const capitalizeFirstLetter = (string) => {
  return String(string).charAt(0).toUpperCase() + String(string).slice(1);
};

export const capitalizeEachWord = (phrase) => {
  return phrase
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatAssessmentOptionCourses = (courses) => {
  let newCourses = courses.map((course) => {
    return {
      id: course.id,
      text: course.name,
    };
  });
  return newCourses;
};

export const formatRegistrationOptionQualification = (courses) => {
  let newCourses = courses.map((course) => {
    return {
      title: course.name,
    };
  });
  return newCourses;
};

const validateHost = (currentHost, targetHost) => {
  if (!currentHost || !targetHost) {
    return false;
  } else {
    // Clean up: remove www prefix, convert to lowercase, and strip port number
    const cleanHost = (host) =>
      host
        .toLowerCase()
        .replace(/^www\./, "")
        .split(":")[0];

    const cleanedCurrentHost = cleanHost(currentHost);
    const cleanedTargetHost = cleanHost(targetHost);

    return cleanedCurrentHost === cleanedTargetHost;
  }
};

export const getDomainITPL = () => {
  let DOMAIN_URL = "https://itpl.cloudxier.dev";

  const IS_PRODUCTION = validateHost(
    window.location.host,
    "assessment.itpl.com.au"
  );

  if (IS_PRODUCTION) {
    DOMAIN_URL = "https://itpl.com.au";
  }

  return DOMAIN_URL;
};

export const getDomainSAG = () => {
  let DOMAIN_URL = "https://interlink-assessment-form.netlify.app";

  const IS_PRODUCTION = validateHost(
    window.location.host,
    "assessment.itpl.com.au"
  );

  if (IS_PRODUCTION) {
    DOMAIN_URL = "https://assessment.itpl.com.au";
  }

  return DOMAIN_URL;
};
